module.exports = __webpack_public_path__ + "static/media/victory.012adf67.mp3";